/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { PerThermPipe } from '../shared/pipes/per-therm.pipe';
import { CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RateDetailComponent } from '../manage-account-feature/rate-detail/rate-detail.component';
import { PageHeaderComponent } from '../shared/components/page-header/page-header.component';
import { SafePipe } from '../shared/pipes/dom-sanitizer.pipe';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { RateService } from '../shared/services/rate.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ActivatedRoute, Router } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../shared/services/error.service';
import { PageHeader } from '../shared/models/page-header.model';
import { CSRData, type Incentive, type Product, type RateOperand, type SSMRateOperand } from '../shared/models/csr';
import { catchError, concatMap, EMPTY, type Observable } from 'rxjs';
import { type Packages } from '../shared/models/packages';
import { addMonths, endOfMonth, format, startOfMonth } from 'date-fns';
import { Nav } from '../shared/enums/nav.enum';
import { StorageEnum } from '../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../shared/services/account.service';
import { RateDetail } from '../shared/models/rate-detail';
import { CTA, SuccessData, SuccessDetails } from '../shared/models/success-data.model';
import { ServiceAddress } from '../shared/models/service-address';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../shared/services/seo.service';
import { type Operand } from '../shared/models/operand';
import { NotificationComponent } from '../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../shared/services/notifications.service';
import { NotificationType } from '../shared/enums/notificationtype.enum';

@Component({
  selector: 'app-unauthenticated-rate-renewal',
  providers: [PerThermPipe, CurrencyPipe],
  imports: [
    MatDividerModule,
    MatButtonModule,
    MatExpansionModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTooltipModule,
    PageHeaderComponent,
    RateDetailComponent,
    PerThermPipe,
    SafePipe,
    NotificationComponent,
  ],
  templateUrl: './unauthenticated-rate-renewal.component.html',
  styleUrl: './unauthenticated-rate-renewal.component.scss',
})
export class UnauthenticatedRateRenewalComponent {
  pageReady = false;
  isBrowser = false;
  formErrorMessage?: string = '';
  pageLabels: any;
  successMessage = '';
  premiseId: string = '';
  currentAddress: ServiceAddress | undefined;
  rateResponse: any;
  rateInfo: any = {};
  oppRates: any[] = [];
  fixedRates: any[] = [];
  sidePanelData: any;
  oppRateHeader = '';
  fixedRateHeader = '';
  cmsModelName: string = '';
  cmsPageName: string = '';
  rateForm: FormGroup;
  isRateSelected = false;
  showRateNotSelectedError = false;
  personId: string = '';
  selectedPlanData: any;
  csrProducts: Product[] = [];
  rateOperands: RateOperand[] = [];
  ssmOperands: SSMRateOperand[] = [];
  rateIncentives: Incentive[] = [];
  csrRequestId: string = '';
  @ViewChild('calculatedTooltip') calculatedTooltip: any;
  headerData = new PageHeader();
  aglAccountNumber = '';
  todoAccountId = '';
  responseOperands: Operand[] = [];
  isMobile = false;
  pageName = 'Unauthenticated Rate Renewal';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly account: AccountService,
    private readonly currencyP: CurrencyPipe,
    private readonly rate: RateService,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
    private readonly perThermP: PerThermPipe,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly error: ErrorService,
    private readonly route: ActivatedRoute,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.sidePanelData = new RateDetail();
    this.rateForm = this.fb.group({
      terms: this.fb.control<boolean>(false, [Validators.requiredTrue]),
    });
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-rate', 'Unauthenticated Rate Renewal')
      .pipe(
        concatMap((data) => {
          this.pageLabels = data;
          this.headerData.Message = this.pageLabels.rateHeaderText;
          this.seoS.setSeoTags(data.seo);
          if (this.isBrowser) {
            return this.getRenewalRatePackages();
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data: Packages) => {
        this.rateResponse = data;
        if (data.Operands !== undefined) {
          this.responseOperands = data.Operands;
        } else {
          this.responseOperands = [{ OperandCode: '', OperandValue: '' }];
        }
        this.currentAddress = new ServiceAddress();
        this.currentAddress = this.rateResponse.ServiceAddress;
        this.setRateInfo(this.rateResponse.RatePackages);
        this.getProductCode();
        this.rateInfo.ProductCodes.forEach((code: any) => {
          if (code === 'OPP') {
            this.oppRates = this.getRatesForProductCode(code);
          } else {
            this.fixedRates = this.getRatesForProductCode(code);
          }
        });
        this.setupInitialSidePanelData();
        this.setPageLabels();
        if (this.isBrowser) {
          this.isMobile = this.utils.isMobile(992);
          if (typeof window !== 'undefined') {
            window.addEventListener('resize', () => {
              this.isMobile = this.utils.isMobile(992);
            });
          }
        }
        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  setRateInfo(rates: any[] | undefined): void {
    if (rates && rates.length > 0) {
      this.rateInfo.DiscountCode = rates[0].DiscountCode;
      this.rateInfo.CSF = rates[0].CSF;
    } else {
      this.rateInfo.DiscountCode = '';
      this.rateInfo.CSF = '0';
    }
  }

  getProductCode(): void {
    const rateArr: string[] = [];
    this.rateResponse.RatePackages.forEach((rate: any) => {
      if (rate.ProductCode !== 'VAR') {
        rateArr.push(rate.ProductCode);
      }
    });
    if (rateArr.length > 1) {
      rateArr.sort((a, b) => {
        return a === 'OPP' ? -1 : 1;
      });
    }
    const rateSet = new Set<string>(rateArr);
    this.rateInfo.ProductCodes = rateSet;
  }

  getRatesForProductCode(productCode: string): any[] {
    const rates = this.rateResponse.RatePackages.filter((rate: any) => {
      return rate.ProductCode === productCode;
    });
    return rates.sort((a: any, b: any) => {
      return parseInt(a.ContractLength) - parseInt(b.ContractLength);
    });
  }

  setPageLabels(): void {
    const productEndDate = format(endOfMonth(new Date().toString()), 'MM/dd/yyyy');
    this.pageLabels.contentSubheader = this.pageLabels.contentSubheader.replace('$END-DATE', productEndDate);

    if (this.oppRates.length > 0 && this.oppRates[0].PlanType === 'BRDG') {
      this.oppRateHeader = this.pageLabels.oppHeader + ' ' + this.pageLabels.bridgeplanHeader;
    } else {
      this.oppRateHeader = this.pageLabels.oppHeader;
    }

    if (this.rateInfo.DiscountCode === 'FF') {
      this.fixedRateHeader = `${this.pageLabels.fixedRateText}<span class="discount-header"> ${this.pageLabels.ffDiscountText}</span>`;
    } else if (this.rateInfo.DiscountCode === 'SR') {
      this.fixedRateHeader = `${this.pageLabels.fixedRateText}<span class="discount-header"> ${this.pageLabels.srDiscountText}</span>`;
    } else {
      this.fixedRateHeader = this.pageLabels.fixedRateText;
    }

    if (this.fixedRates.length > 0 && this.fixedRates[0].PlanType === 'BRDG') {
      this.fixedRateHeader += ' ' + this.pageLabels.bridgeplanHeader;
    }

    const csf = this.currencyP.transform(this.rateResponse.RatePackages[0].CancellationFee); // Cancellation fee is the same for all packages
    this.pageLabels.oppDisclaimer = this.pageLabels.oppDisclaimer.replace('$CANCELLATION_FEE', csf);
    this.pageLabels.fixedDisclaimer = this.pageLabels.fixedDisclaimer.replace('$CANCELLATION_FEE', csf);

    // have to insert button like this because it's in the middle of text
    // inserting non-standard(mat components) elements into the pagelabel and putting it as innerhtml doesnt work
    const inter = setInterval(() => {
      const insertSpan = document.getElementsByClassName('therm-tt')[0];
      if (insertSpan) {
        const ttBtn = document.getElementById('fixedThermTT');
        if (ttBtn) {
          insertSpan.appendChild(ttBtn);
          clearInterval(inter);
        }
      }
    }, 100);
  }

  getRenewalRatePackages(): Observable<any> {
    const queryParams = this.route.snapshot.queryParams;
    const acctNumberParam = queryParams['accountnumber'];
    const encodedacctNumberParam = decodeURIComponent(acctNumberParam);
    return this.rate.getUnathenticatedRenewalRatePackages(encodedacctNumberParam).pipe(
      catchError((e) => {
        this.setRatesErrorData();
        void this.router.navigateByUrl(Nav.UnauthenticatedRateRenewalError);
        return EMPTY;
      }),
    );
  }

  confirmRenewal(): void {
    this.formErrorMessage = '';
    this.rateForm.markAllAsTouched();
    this.utils.showSpinner();
    if (this.rateForm.valid && this.isRateSelected) {
      this.rate
        .getUnAuthenicatedPersonId(this.selectedPlanData.accountNumber)
        .pipe(
          catchError((e) => {
            this.setRatesErrorData();
            void this.router.navigateByUrl(Nav.UnauthenticatedRateRenewalError);
            return EMPTY;
          }),
          concatMap((data: string) => {
            this.personId = data.toString();
            const csrRequest: CSRData[] = this.createCSRData();
            return this.rate.createCSR({ Customers: csrRequest }).pipe(
              catchError((e) => {
                this.setRatesErrorData();
                void this.router.navigateByUrl(Nav.UnauthenticatedRateRenewalError);
                return EMPTY;
              }),
            );
          }),
        )
        .subscribe((data: any) => {
          const resp = data;
          this.csrRequestId = resp[0].CustomerServiceRequestId;
          this.setSuccessData();
          void this.router.navigateByUrl(Nav.UnauthenticatedRateRenewalSuccess);
        });
    } else {
      if (!this.isRateSelected) {
        this.showRateNotSelectedError = true;
      }
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.showFormErrorLabel(errorMessage);
      this.utils.hideSpinner();
    }
  }

  createCSRData(): CSRData[] {
    const csrRequest = new CSRData();
    const packageId = this.selectedPlanData.packageId;
    const isOPP = this.selectedPlanData.evenBill;
    const ratePerTherm = this.selectedPlanData.pricePerTherm;
    const oppAmount = isOPP ? ratePerTherm : '';
    const ratePlan = this.selectedPlanData.packageTerm;
    const custSerFee = this.selectedPlanData.orderCSFVal;
    const csrReqId = this.selectedPlanData.csrReqId;
    const customerClass = this.selectedPlanData.packageId.includes('RES') ? 'RES' : 'SMLCOM';
    const discountCode = this.selectedPlanData.discountCode;

    let productStartDate = '';
    let productEndDate = '';

    const todayNextMonth = addMonths(new Date(), 1);
    productStartDate = format(startOfMonth(todayNextMonth), 'MM/dd/yyyy');
    productEndDate = format(endOfMonth(new Date().toString()), 'MM/dd/yyyy');
    csrRequest.IsRenewal = 'Y';

    this.csrProducts = [
      {
        ProductSequence: '1',
        PreferredConnectionDate: productEndDate,
        ProductAction: 'C1ED',
        Version: '',
        RelatedProductSequence: '',
        SaId: this.selectedPlanData.saId,
        ProductId: packageId,
      },
      {
        ProductSequence: '2',
        PreferredConnectionDate: productStartDate,
        ProductAction: 'C1AD',
        Version: '',
        RelatedProductSequence: '1',
        SaId: '',
        ProductId: packageId,
      },
    ];

    this.responseOperands.forEach((element: Operand) => {
      const item: RateOperand = {
        Code: element.OperandCode,
        Value: element.OperandValue,
      };
      this.rateOperands.push(item);
    });

    this.rateIncentives = [{ Type: '', Value: '' }];

    csrRequest.PreferredConnectionDate = format(new Date().toString(), 'MM/dd/yyyy');
    csrRequest.RatePerTherm = ratePerTherm;
    csrRequest.DiscountCode = discountCode;
    csrRequest.RatePlan = ratePlan;
    csrRequest.CsrId = csrReqId;
    csrRequest.MainCustomer = '';
    csrRequest.MainPersonId = this.personId;
    csrRequest.ContractDate = format(new Date().toString(), 'MM/dd/yyyy');
    csrRequest.Products = this.csrProducts;
    csrRequest.Operands = this.rateOperands;
    csrRequest.Incentives = this.rateIncentives;
    csrRequest.OppAmount = oppAmount;
    csrRequest.CustomerServiceFee = custSerFee;
    csrRequest.CustomerClass = customerClass;
    csrRequest.GSAccountNumber = this.selectedPlanData.accountNumber;
    csrRequest.SalesChannel = this.isMobile ? 'MOBILE' : 'WEB';

    return [csrRequest];
  }

  selectRate(productCode: string, index: number, rate: any): void {
    document.querySelector('.selected')?.classList.remove('selected');

    document.querySelector(`.${productCode}-tile-${index}`)?.classList.add('selected');
    this.isRateSelected = true;
    this.showRateNotSelectedError = false;
    if (rate.ProductCode === 'OPP') {
      this.sidePanelData.PlanType = this.oppRateHeader;
      this.sidePanelData.PricePerTherm =
        this.perThermP.transform(rate.PricePerTherm) + ' ' + this.pageLabels.pricePerMonthText;
      this.sidePanelData.ProductCode = rate.ProductCode;
    } else if (rate.ProductCode === 'FIXED') {
      this.sidePanelData.PlanType = this.fixedRateHeader;
      this.sidePanelData.PricePerTherm =
        this.perThermP.transform(rate.PricePerTherm) + ' ' + this.pageLabels.pricePerThermText;
      this.sidePanelData.ProductCode = rate.ProductCode;
    }
    this.sidePanelData.ContractLength = rate.ContractLength + ' ' + this.pageLabels.rateTermMonthsText;
    this.sidePanelData.CustomerServiceFee = parseFloat(rate.CSF).toFixed(2);
    this.setSelectedPlanData(rate);
  }

  setSelectedPlanData(rate: any): void {
    this.selectedPlanData = {
      accountNumber: rate.AccountNumber,
      saId: rate.SaId,
      packageTerm: rate.ContractLength,
      orderCSFVal: rate.CSF,
      orderType: rate.Type,
      orderId: rate.OrderId,
      packageId: rate.PackageId,
      pricePerTherm: rate.PricePerTherm,
      evenBill: rate.EvenBill,
      discountCode: rate.DiscountCode,
      description: rate.Description,
      csrReqId: rate.CSRRequestId,
      pricePerThermUndiscounted: rate.PricePerThermUndiscounted,
    };
  }

  setupInitialSidePanelData(): void {
    this.sidePanelData.PlanType = '';
    this.sidePanelData.Address = this.currentAddress?.Address1;
    this.sidePanelData.City = this.currentAddress?.City + ', ';
    this.sidePanelData.State = this.currentAddress?.State;
    this.sidePanelData.PostalCode = this.currentAddress?.PostalCode;
  }

  openCalculatedTooltip(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    this.dialog.open(this.calculatedTooltip, {
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: {
        header: this.pageLabels.calculatedHeader,
        bodyText: this.pageLabels.calculatedBodyText,
        ctaBtnText: this.pageLabels.calculatedCtaText,
      },
    });
  }

  setSuccessData(): void {
    const successLabels = this.pageLabels.rateChangeSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    successData.Subheader = successLabels.subheaderText;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'unauthRateRenewalSuccess';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = acctCTA.ctaUrl;
    successData.CTAList.push(cta);
    successData.Details = [];
    const detail1 = new SuccessDetails();
    detail1.Label = this.sidePanelData.ContractLength + ' ' + this.sidePanelData.PlanType + ' ';
    detail1.Value = this.sidePanelData.PricePerTherm;
    successData.Details.push(detail1);
    if (this.sidePanelData.ProductCode === 'FIXED') {
      const detail2 = new SuccessDetails();
      detail2.Label = successLabels.details[1].detailLabel;
      detail2.Value = this.perThermP.transform(this.sidePanelData.CustomerServiceFee);
      successData.Details.push(detail2);
    }
    const detail3 = new SuccessDetails();
    detail3.Label = successLabels.details[2].detailLabel;
    detail3.Value = this.csrRequestId;
    successData.Details.push(detail3);
    this.storage.setSession(StorageEnum.SuccessData, successData);
  }

  setRatesErrorData(): void {
    this.error.setErrorData('none', this.pageLabels.getRatesErrorData);
  }

  setCreateCrsErrorData(): void {
    this.error.setErrorData('none', this.pageLabels.createCsrErrorData);
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }
}
